import { Injectable } from '@angular/core'
import { News } from '@interface/news'
import { ImageConfig } from '@model/image-config/image-config'
import { SerializationService } from 'aautil'
import { RestService } from './rest/rest.service'
import { SentryService } from './sentry.service'
import { imageDefinitions } from '@configuration/image-definitions'

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(
    private serializationService: SerializationService,
    private restService: RestService,
    private sentryService: SentryService,
  ) { }

  public getAll(imageConfig?: ImageConfig): Promise<News> {
    return new Promise((resolve, reject) => {

      this.restService.post('news/v1', {}, imageDefinitions.news.default_listview, false)
        .then((response: object) => {

          this.serializationService.deserialize(News, response)
            .then((result: News) => resolve(result))
            .catch(err => {
              this.sentryService.silentCaptureException(err)
              reject(err)
            })
        })
        .catch(err => {
          this.sentryService.silentCaptureException(err)
          reject(err)
        })

    })
  }
}
